// extracted by mini-css-extract-plugin
export default {"notes":"styles_notes__smLj-"};